var app = angular.module("leonardo");

var ChangeStatusAllDialog = function($scope, $rootScope, TemplateService, FormErrorsService) {

  $scope.status = $scope.ngDialogData.disable ? TemplateService.STATUS_UNPUBLISHED : TemplateService.STATUS_PUBLISHED;

  $scope.submit = function() {
    $scope.Form.$setSubmitted();
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    TemplateService.changeStatusAll({new_status:$scope.status}).then(function() {
      $rootScope.$broadcast('templates-status:updated');
      $scope.closeThisDialog();
    });
  };
};

app.controller('ChangeStatusAllDialog', ['$scope', '$rootScope', 'TemplateService', 'FormErrorsService',
  ChangeStatusAllDialog]);
